var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 385.321,
    height: 337.353,
    viewBox: "0 0 385.321 337.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5962",
    "data-name": "Rectangle 5962",
    width: 385.321,
    height: 337.353,
    transform: "translate(-31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5929",
    "data-name": "Rectangle 5929",
    width: 340.445,
    height: 34.719,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5931",
    "data-name": "Rectangle 5931",
    width: 59.653,
    height: 91.52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5932",
    "data-name": "Rectangle 5932",
    width: 24.374,
    height: 26.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5933",
    "data-name": "Rectangle 5933",
    width: 40.53,
    height: 38.704,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5934",
    "data-name": "Rectangle 5934",
    width: 37.9,
    height: 12.128,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5935",
    "data-name": "Rectangle 5935",
    width: 42.024,
    height: 10.418,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5936",
    "data-name": "Rectangle 5936",
    width: 43.183,
    height: 34.22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5942",
    "data-name": "Rectangle 5942",
    width: 61.204,
    height: 38.489,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5943",
    "data-name": "Rectangle 5943",
    width: 27.859,
    height: 18.446,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5944",
    "data-name": "Rectangle 5944",
    width: 60.247,
    height: 32.172,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5945",
    "data-name": "Rectangle 5945",
    width: 87.045,
    height: 38.469,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5946",
    "data-name": "Rectangle 5946",
    width: 51.471,
    height: 34.189,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5947",
    "data-name": "Rectangle 5947",
    width: 34.89,
    height: 23.733,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5948",
    "data-name": "Rectangle 5948",
    width: 9.984,
    height: 7.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5949",
    "data-name": "Rectangle 5949",
    width: 39.176,
    height: 13.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5950",
    "data-name": "Rectangle 5950",
    width: 28,
    height: 52.603,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5951",
    "data-name": "Rectangle 5951",
    width: 82.686,
    height: 61.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5952",
    "data-name": "Rectangle 5952",
    width: 19.522,
    height: 22.395,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5953",
    "data-name": "Rectangle 5953",
    width: 8.052,
    height: 9.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5954",
    "data-name": "Rectangle 5954",
    width: 18.127,
    height: 28.454,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5955",
    "data-name": "Rectangle 5955",
    width: 20.7,
    height: 13.078,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5956",
    "data-name": "Rectangle 5956",
    width: 33.114,
    height: 8.387,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5957",
    "data-name": "Rectangle 5957",
    width: 24.179,
    height: 23.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5930",
    "data-name": "Rectangle 5930",
    width: 7.628,
    height: 21.964,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5937",
    "data-name": "Rectangle 5937",
    width: 38.697,
    height: 26.28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5938",
    "data-name": "Rectangle 5938",
    width: 130.732,
    height: 113.381,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5939",
    "data-name": "Rectangle 5939",
    width: 76.368,
    height: 33.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5940",
    "data-name": "Rectangle 5940",
    width: 18.407,
    height: 39.887,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5958",
    "data-name": "Rectangle 5958",
    width: 19.075,
    height: 15.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5959",
    "data-name": "Rectangle 5959",
    width: 7.724,
    height: 8.028,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5960",
    "data-name": "Rectangle 5960",
    width: 23.866,
    height: 38.164,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7089",
    "data-name": "Group 7089",
    transform: "translate(31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7088",
    "data-name": "Group 7088",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7087",
    "data-name": "Group 7087",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7090",
    "data-name": "Group 7090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(-26.125 302.635)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6991",
    "data-name": "Group 6991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6990",
    "data-name": "Group 6990",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10264",
    "data-name": "Path 10264",
    d: "M454.213,2498.7c0,9.587-76.211,17.359-170.223,17.359s-170.223-7.772-170.223-17.359,76.211-17.36,170.223-17.36,170.223,7.773,170.223,17.36",
    transform: "translate(-113.767 -2481.344)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Astronaut",
    transform: "translate(175.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10269",
    "data-name": "Path 10269",
    d: "M213.176,1348.821l.709,9.847.364,5.016,6.243,86.5s-5.922.091-13.873-.425c-1.555-.1-3.189-.224-4.87-.377-12.529-1.128-27.74-3.836-33.516-10.276-8.634-9.631-10.074-56.656-2.365-75.3,3.531-8.548,21.477-12.271,34.221-13.856,1.424-.18,2.785-.33,4.051-.456,5.34-.541,9.036-.67,9.036-.67",
    transform: "translate(-141.223 -1184.313)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6998",
    "data-name": "Group 6998",
    transform: "translate(19.616 174.355)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6997",
    "data-name": "Group 6997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6996",
    "data-name": "Group 6996",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10270",
    "data-name": "Path 10270",
    d: "M213.88,1429.562l.363,5.016,4.957,68.68,1.286,17.817-.359,0c-.067,0-.146,0-.23,0h-.217c-.057,0-.115,0-.173,0-.022,0-.049,0-.071,0-.107,0-.226,0-.351,0a.574.574,0,0,1-.084,0h-.324c-.155,0-.315,0-.484,0-.12,0-.248,0-.377,0l-.4,0c-.173,0-.355-.006-.542-.006-.378-.008-.777-.013-1.2-.024-.373,0-.764-.014-1.174-.028-.472-.014-.965-.026-1.477-.044-1.892-.065-4.059-.164-6.406-.317-.456-.029-.921-.062-1.39-.094-.326-.023-.662-.049-1-.075-.81-.062-1.643-.13-2.481-.207-12.533-1.127-27.74-3.836-33.512-10.277-7.112-7.929-9.349-41.214-5.607-63.134-.644,19.06,1.942,39.431,7.3,45.406,2.65,2.955,12.842-7.868,12.532-13.969-.8-15.732,1.278-36.046,15.519-48.412.37-.321,8.87.572,15.9-.326",
    transform: "translate(-160.833 -1429.562)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10271",
    "data-name": "Path 10271",
    d: "M205.327,1437.943c-7.6,0-42.334-.619-52.287-11.72-9.092-10.141-10.763-57.824-2.709-77.3,2.582-6.246,11.723-10.858,27.167-13.708a166.227,166.227,0,0,1,21.837-2.446l1.834-.064,7.6,105.2-2.016.031c-.16,0-.652.008-1.421.008m-7.692-101.288c-12.391.656-39.792,4.069-43.783,13.721-7.327,17.722-6.04,64.308,2.026,73.3,8.54,9.525,40.424,10.386,48.794,10.446Z",
    transform: "translate(-127.449 -1170.16)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10272",
    "data-name": "Path 10272",
    d: "M163.866,1798.124l17.032.832a3.339,3.339,0,0,1,3.111,2.652c1.135,5.458,3.1,18.2-2.12,22.561-4.336,3.62-11.535,3.4-15.84-.059-4.816-3.865-5.6-16.391-5.69-22.6a3.343,3.343,0,0,1,3.508-3.386",
    transform: "translate(-140.8 -1578.813)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7001",
    "data-name": "Group 7001",
    transform: "translate(20.159 221.647)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7000",
    "data-name": "Group 7000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6999",
    "data-name": "Group 6999",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10273",
    "data-name": "Path 10273",
    d: "M188.338,1818.464c1.138,5.456,3.1,18.2-2.121,22.558-4.336,3.622-11.534,3.4-15.842-.058-2.96-2.379-4.4-8.033-5.086-13.476a14.271,14.271,0,0,0,3.63,6.3c8.785,8.1,14.924-1.881,14.924-1.881s1.172,2.354,2.06,2.466c3.714.468,2.646-11.092,1.955-17.061a3.237,3.237,0,0,1,.478,1.149",
    transform: "translate(-165.29 -1817.315)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10274",
    "data-name": "Path 10274",
    d: "M160.383,1814.984a14.83,14.83,0,0,1-9.241-3.106c-5.073-4.071-6.282-15.331-6.4-24.061a5.247,5.247,0,0,1,5.506-5.315l17.032.832a5.246,5.246,0,0,1,4.883,4.168c1.463,7.033,3.05,19.556-2.764,24.411a14.087,14.087,0,0,1-9.013,3.071m-10.4-28.678a1.439,1.439,0,0,0-1.438,1.459c.151,10.858,2.011,18.761,4.977,21.141,3.738,3,9.887,3.037,13.427.082,3.635-3.034,3.146-12.688,1.476-20.71a1.436,1.436,0,0,0-1.338-1.138l-17.031-.832-.073,0",
    transform: "translate(-127.086 -1565.095)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10275",
    "data-name": "Path 10275",
    d: "M253.544,1874.226c5.586-3.447,6.3-10.934,6.019-16.944a14.334,14.334,0,0,0-.4-2.806.5.5,0,0,1,.951-.312,28.652,28.652,0,0,1,1.2,8.914c.07,5.257-1.7,11.183-6.343,14.208a1.7,1.7,0,1,1-1.432-3.059",
    transform: "translate(-221.615 -1627.744)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10276",
    "data-name": "Path 10276",
    d: "M218.279,1442.5c-8.124-.173-16.573-.324-24.495,1.565a1.907,1.907,0,0,1-1-3.68c6.451-1.171,12.888-.8,19.354-.412,2.1.152,4.191.331,6.3.569a.982.982,0,0,1-.159,1.958",
    transform: "translate(-168.049 -1264.018)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10277",
    "data-name": "Path 10277",
    d: "M414.743,1917.331c-.359,5.4-1.09,21.886-1.891,38.622-.965,20.224-2.029,40.821-2.674,42.672a8.76,8.76,0,0,1-6.958,6.041H383.529s-6.019-.009-8.667-3.211c-4.349-5.261.074-10.986.074-10.986s-.333-23.859-.55-45.7c-.091-9.385-.16-18.4-.173-24.988Z",
    transform: "translate(-327.462 -1683.486)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7004",
    "data-name": "Group 7004",
    transform: "translate(46.751 233.845)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7003",
    "data-name": "Group 7003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7002",
    "data-name": "Group 7002",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10278",
    "data-name": "Path 10278",
    d: "M423.849,1917.331c-.359,5.4-1.09,21.886-1.891,38.622-15.1.965-27.346-6.845-38.467-11.181-.091-9.385-.16-18.4-.173-24.988Z",
    transform: "translate(-383.319 -1917.331)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7007",
    "data-name": "Group 7007",
    transform: "translate(45.487 309.052)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7006",
    "data-name": "Group 7006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7005",
    "data-name": "Group 7005",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10279",
    "data-name": "Path 10279",
    d: "M410.859,2533.962a44.967,44.967,0,0,1-.671,6.088,8.761,8.761,0,0,1-6.958,6.041H383.539s-6.019-.009-8.667-3.211a7.964,7.964,0,0,1-1.592-7.455s0,.009.009.012c2.869,3.466,9.39,3.475,9.39,3.475h21.336a9.369,9.369,0,0,0,6.845-4.95",
    transform: "translate(-372.96 -2533.962)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10280",
    "data-name": "Path 10280",
    d: "M389.588,1992.84H369.9c-.71,0-7.006-.117-10.133-3.9-3.9-4.724-2.129-10.124-.373-12.792-.079-5.752-.678-49.76-.714-70.088a1.9,1.9,0,0,1,1.9-1.908h0a1.9,1.9,0,0,1,1.905,1.9c.038,21.64.715,70.175.722,70.662a1.906,1.906,0,0,1-.4,1.192c-.135.179-3.415,4.608-.111,8.605,1.689,2.044,5.771,2.51,7.2,2.517h19.567a6.893,6.893,0,0,0,5.278-4.76c.729-2.6,2.226-34.638,3.217-55.84.528-11.289.983-21.039,1.245-24.956a1.905,1.905,0,1,1,3.8.254c-.259,3.879-.714,13.611-1.241,24.88-1.722,36.841-2.673,54.754-3.424,56.915a10.631,10.631,0,0,1-8.575,7.31,1.817,1.817,0,0,1-.182.009",
    transform: "translate(-313.83 -1669.756)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10281",
    "data-name": "Path 10281",
    d: "M775.094,2025.64c2.3,2.851,2.609,6.975-.541,9.874s-15.023,2.306-15.023,2.306H742.356a8.759,8.759,0,0,1-6.958-6.041c-1.5-4.31-.61-22.1-1.147-42.417-.113-4.314-.29-8.74-.567-13.176l43.183-21.038c-.671,7.923-1.406,15.677-2.151,22.942-2.544,24.94-5.127,44.07-5.127,44.07a12.514,12.514,0,0,1,5.5,3.479",
    transform: "translate(-644.202 -1716.691)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7010",
    "data-name": "Group 7010",
    transform: "translate(90.641 310.76)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7009",
    "data-name": "Group 7009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7008",
    "data-name": "Group 7008",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10282",
    "data-name": "Path 10282",
    d: "M782.889,2556.032c-3.153,2.9-15.021,2.305-15.021,2.305H750.694a8.762,8.762,0,0,1-6.958-6.039,14.421,14.421,0,0,1-.557-3.1,9.468,9.468,0,0,0,4.429,1.919h19.417s13.416.667,16.983-2.609a7.17,7.17,0,0,0,.534-.539,6.807,6.807,0,0,1-1.653,8.063",
    transform: "translate(-743.179 -2547.969)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7013",
    "data-name": "Group 7013",
    transform: "translate(89.482 238.458)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7012",
    "data-name": "Group 7012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7011",
    "data-name": "Group 7011",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10283",
    "data-name": "Path 10283",
    d: "M776.867,1955.15c-.671,7.923-1.406,15.677-2.151,22.942a70.359,70.359,0,0,0-9.757,4.262c-12.552,6.616-25.888,7.087-30.708,7.01-.112-4.314-.29-8.74-.567-13.176Z",
    transform: "translate(-733.684 -1955.15)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10284",
    "data-name": "Path 10284",
    d: "M748.56,2026.087c-1.264,0-2.262-.038-2.79-.064H728.643q-.091,0-.182-.009a10.632,10.632,0,0,1-8.575-7.31c-1.046-3.008-1.047-10.536-1.049-21.93,0-9.8,0-22-.767-34.169a1.9,1.9,0,1,1,3.8-.238c.771,12.289.773,24.552.775,34.407,0,9.808,0,18.278.838,20.678a6.9,6.9,0,0,0,5.284,4.76h17.049c.031,0,.063,0,.094,0,4.6.227,11.87-.183,13.636-1.807,2.466-2.267,1.952-5.288.35-7.276a10.64,10.64,0,0,0-4.559-2.846,1.911,1.911,0,0,1-1.35-2.083c.043-.319,4.332-32.251,7.268-66.916a1.905,1.905,0,0,1,3.8.322c-2.583,30.491-6.209,58.874-7.09,65.6a13.173,13.173,0,0,1,4.9,3.528,8.945,8.945,0,0,1-.737,12.472c-2.7,2.479-9.5,2.874-13.566,2.874",
    transform: "translate(-630.487 -1702.989)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10285",
    "data-name": "Path 10285",
    d: "M742.73,2315.365a91.033,91.033,0,0,1-16.985-1.6,1.905,1.905,0,0,1,.778-3.73c.218.045,21.959,4.454,36.858-2.126a1.905,1.905,0,0,1,1.539,3.485c-6.98,3.083-15.133,3.968-22.19,3.968",
    transform: "translate(-635.899 -2026.286)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10286",
    "data-name": "Path 10286",
    d: "M393.345,2296.841c-12.729,0-20.849-2.923-21.319-3.1a1.9,1.9,0,0,1,1.317-3.575c.152.056,15.489,5.531,36.808,1.115a1.9,1.9,0,1,1,.773,3.73,86.646,86.646,0,0,1-17.579,1.825",
    transform: "translate(-325.559 -2010.748)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10287",
    "data-name": "Path 10287",
    d: "M373.64,2486.288c6.18-4.523,20.352-1.971,27.733-1.072a.954.954,0,0,1-.207,1.894c-2.232-.163-4.461-.3-6.685-.391-4.888-.165-9.9-.274-14.652.8a9.366,9.366,0,0,0-3.813,1.747,1.906,1.906,0,1,1-2.376-2.98",
    transform: "translate(-327.389 -2180.763)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10288",
    "data-name": "Path 10288",
    d: "M925.516,2490.2a39.332,39.332,0,0,0-12.763-1.381.956.956,0,0,1-.2-1.894,41.867,41.867,0,0,1,13.856-.428,1.909,1.909,0,1,1-.893,3.7",
    transform: "translate(-800.574 -2182.883)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M1030.873,1615.526s18.83,10.24,26.916,2.305c12.473-12.241-2.4-36.826-2.4-36.826Z",
    transform: "translate(-905.144 -1388.18)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M1035.43,1609.027c-8.859,0-18.605-5.222-19.182-5.535a1.9,1.9,0,0,1-.643-2.776l24.514-34.52a1.932,1.932,0,0,1,1.623-.8,1.907,1.907,0,0,1,1.56.918c.639,1.057,15.5,26.026,2.106,39.172-2.666,2.616-6.243,3.544-9.978,3.544m-15.435-7.914c5.953,2.8,17.587,6.711,22.744,1.651,9-8.832,1.959-25.458-1.285-31.869Z",
    transform: "translate(-891.429 -1374.471)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M88.589,1102.8a133.183,133.183,0,0,1-11.082,13.735c-3.162,3.491-5.553,5.9-5.553,5.9s-41.591,2.91-53.036-27.728a47.611,47.611,0,0,1-2.615-10.687c-2.5-19.422,6.491-36.81,6.491-36.81L45.259,1057.8l6.482,21.546a117.539,117.539,0,0,0,13.173,5.01,176.871,176.871,0,0,0,25.142,6.139c4.729.8,2.667,6.177-1.467,12.306",
    transform: "translate(-13.929 -919.489)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7031",
    "data-name": "Group 7031",
    transform: "translate(2.374 164.532)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7030",
    "data-name": "Group 7030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7029",
    "data-name": "Group 7029",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M80.669,1381.534c-3.162,3.491-5.553,5.9-5.553,5.9s-41.592,2.91-53.036-27.728a47.6,47.6,0,0,1-2.615-10.687c2.191,6.063,13.345,30.628,50.259,31.661a93.8,93.8,0,0,1,10.944.853",
    transform: "translate(-19.465 -1349.02)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7034",
    "data-name": "Group 7034",
    transform: "translate(50.985 164.865)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7033",
    "data-name": "Group 7033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7032",
    "data-name": "Group 7032",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M441.713,1370.2a47.193,47.193,0,0,1-23.675-18.446,176.882,176.882,0,0,0,25.142,6.139c4.729.8,2.667,6.177-1.467,12.306",
    transform: "translate(-418.038 -1351.753)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M558.96,1290.141a52.888,52.888,0,0,1-27.88,7.758,52.134,52.134,0,0,1-32.367-10.916l13.392-21.255,46.649,24.056c.067.119.138.239.2.357",
    transform: "translate(-437.888 -1111.355)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M55.08,1110.693a80.1,80.1,0,0,1-19.764-2.516c-16.1-4.224-27.206-13.4-32.112-26.528-8.871-23.742,3.441-48.02,3.969-49.042a1.905,1.905,0,0,1,3.384,1.75c-.152.3-12.043,23.856-3.785,45.959,10.014,26.8,45.019,26.706,50.422,26.525,10.453-10.617,20.831-24.025,19.681-27.6-.042-.13-.14-.437-1.064-.593-23.147-3.9-38.193-11.009-38.822-11.31a1.905,1.905,0,0,1-1-1.17L29.5,1044.621a1.905,1.905,0,1,1,3.649-1.1l6.232,20.715a162.626,162.626,0,0,0,37.059,10.649,4.731,4.731,0,0,1,4.059,3.183c.739,2.3.525,6.822-9.83,19.443-5.442,6.633-11.238,12.481-11.3,12.539a1.905,1.905,0,0,1-1.218.557c-.137.009-1.248.083-3.078.083",
    transform: "translate(-0.001 -905.761)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10325",
    "data-name": "Path 10325",
    d: "M478.573,1343.763c-.486,8.868-2.886,16.9-8.12,22.718-18.226,20.251-67.038,16.293-76.83-9.249-1.605-4.182-2.2-9.9-2.081-16.317.281-15.831,4.863-35.915,9.125-47.688l17.326-27.5,46.649,24.056c7.477,12.969,14.95,35.31,13.931,53.979",
    transform: "translate(-343.775 -1111.355)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7037",
    "data-name": "Group 7037",
    transform: "translate(60.825 154.374)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7036",
    "data-name": "Group 7036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7035",
    "data-name": "Group 7035",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M558.96,1290.141a52.888,52.888,0,0,1-27.88,7.758,52.134,52.134,0,0,1-32.367-10.916l13.392-21.255,46.649,24.056c.067.119.138.239.2.357",
    transform: "translate(-498.713 -1265.728)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7040",
    "data-name": "Group 7040",
    transform: "translate(47.752 229.56)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7039",
    "data-name": "Group 7039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7038",
    "data-name": "Group 7038",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M478.573,1885.044c-.486,8.868-2.886,16.9-8.12,22.717-18.226,20.25-67.038,16.293-76.83-9.249-1.605-4.182-2.2-9.9-2.081-16.317,17.36,3.134,59.594,9.473,87.031,2.848",
    transform: "translate(-391.528 -1882.196)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10328",
    "data-name": "Path 10328",
    d: "M379.658,1655.079c-8.432-13.631-3.022-38.442,1.518-52.987a.956.956,0,0,1,1.849.458,263.346,263.346,0,0,0-3.392,26.144c-.432,6.485-.9,12.965.079,19.378a26.891,26.891,0,0,0,1.642,6.149.958.958,0,0,1-1.7.858",
    transform: "translate(-329.469 -1406.126)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10329",
    "data-name": "Path 10329",
    d: "M673.962,2178.677c-8.331,3.446-18.307,3.354-26.783.449a.968.968,0,0,1,.364-1.871c6.294.245,13.2.342,19.454-.061,2.157-.119,4.316-.278,6.533-.371a.971.971,0,0,1,.433,1.854",
    transform: "translate(-567.701 -1911.328)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10330",
    "data-name": "Path 10330",
    d: "M979,1448.463c10.689,18.358,19.475,49.267,11.03,69.7a24.183,24.183,0,0,1-6.162,8.591.96.96,0,0,1-1.416-1.274c11.089-16.929,6.872-38.765,1.076-56.891a112.711,112.711,0,0,0-7.835-18.232,1.906,1.906,0,0,1,3.307-1.891",
    transform: "translate(-856.479 -1270.986)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10331",
    "data-name": "Path 10331",
    d: "M1026.549,1855.592a6.326,6.326,0,1,1-6.326-6.326,6.326,6.326,0,0,1,6.326,6.326",
    transform: "translate(-890.238 -1623.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10332",
    "data-name": "Path 10332",
    d: "M1006.509,1850.107a8.231,8.231,0,1,1,8.231-8.231,8.24,8.24,0,0,1-8.231,8.231m0-12.652a4.421,4.421,0,1,0,4.421,4.421,4.426,4.426,0,0,0-4.421-4.421",
    transform: "translate(-876.524 -1610.006)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10333",
    "data-name": "Path 10333",
    d: "M697.059,1806.1l-35.7.733a7.712,7.712,0,0,1-7.846-7.53l-.389-19a7.716,7.716,0,0,1,6-7.658,7.462,7.462,0,0,1,1.533-.187l35.7-.733a7.705,7.705,0,0,1,7.845,7.53l.312,15.048.083,3.952a7.712,7.712,0,0,1-7.53,7.845",
    transform: "translate(-573.463 -1555.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10334",
    "data-name": "Path 10334",
    d: "M697.059,1806.1l-35.7.733a7.712,7.712,0,0,1-7.846-7.53l-.389-19a7.716,7.716,0,0,1,6-7.658,7.462,7.462,0,0,1,1.533-.187l35.7-.733a7.705,7.705,0,0,1,7.845,7.53l.312,15.048.083,3.952a7.712,7.712,0,0,1-7.53,7.845",
    transform: "translate(-573.463 -1555.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10335",
    "data-name": "Path 10335",
    d: "M697.059,1806.1l-35.7.733a7.712,7.712,0,0,1-7.846-7.53l-.389-19a7.716,7.716,0,0,1,6-7.658,7.462,7.462,0,0,1,1.533-.187l35.7-.733a7.705,7.705,0,0,1,7.845,7.53l.312,15.048.083,3.952a7.712,7.712,0,0,1-7.53,7.845",
    transform: "translate(-573.463 -1555.634)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7043",
    "data-name": "Group 7043",
    transform: "translate(79.71 217.01)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7042",
    "data-name": "Group 7042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7041",
    "data-name": "Group 7041",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10336",
    "data-name": "Path 10336",
    d: "M697.491,1812.75l-35.7.733a7.712,7.712,0,0,1-7.845-7.53l-.389-19a7.716,7.716,0,0,1,6-7.658c2.055,1.3,3.36,2.14,3.36,2.14,2.051,15.215,6.55,22.731,25.495,22.651,8.177-.036,13.312-1.389,16.533-3.133l.083,3.951a7.712,7.712,0,0,1-7.53,7.845",
    transform: "translate(-653.552 -1779.295)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10337",
    "data-name": "Path 10337",
    d: "M649.309,1795.214a11.229,11.229,0,0,1-11.211-10.985l-.324-15.76a11.228,11.228,0,0,1,10.982-11.444l32.46-.667a11.242,11.242,0,0,1,11.443,10.982l.324,15.761A11.228,11.228,0,0,1,682,1794.544l-32.459.668-.233,0m.194-1.907h0Zm31.946-33.142h-.154l-32.46.667a7.434,7.434,0,0,0-7.252,7.557l.324,15.76a7.415,7.415,0,0,0,7.556,7.253l32.459-.668a7.414,7.414,0,0,0,7.252-7.556l-.324-15.761a7.434,7.434,0,0,0-7.4-7.253",
    transform: "translate(-559.987 -1542.142)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10338",
    "data-name": "Path 10338",
    d: "M684.434,1810.4l-.069.137-23.006.471a7.706,7.706,0,0,1-7.085-4.377,7.508,7.508,0,0,1-.754-3.154l-.177-8.441-.058-2.786-.1-4.89-.06-2.882a7.712,7.712,0,0,1,7.528-7.847l7.714-.155a7.71,7.71,0,0,0-6.11,7.672l.114,5.64.1,4.624.176,8.745a7.724,7.724,0,0,0,7.847,7.529Z",
    transform: "translate(-573.469 -1559.812)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7046",
    "data-name": "Group 7046",
    transform: "translate(79.72 227.467)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7045",
    "data-name": "Group 7045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7044",
    "data-name": "Group 7044",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10339",
    "data-name": "Path 10339",
    d: "M688.526,1888.078l-.069.136-26.65.548a7.705,7.705,0,0,1-7.085-4.376,7.513,7.513,0,0,1-.754-3.155l-.177-8.441-.058-2.786-.1-4.89a4.183,4.183,0,0,1,4.762,2.189c1.613,3.136,3.23,2.047,4.424.239l.1,4.624.176,8.745a7.723,7.723,0,0,0,7.847,7.528Z",
    transform: "translate(-653.636 -1865.031)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10340",
    "data-name": "Path 10340",
    d: "M647.486,1799.174a9.615,9.615,0,0,1-9.581-9.4l-.39-19a9.617,9.617,0,0,1,9.394-9.791l7.713-.157.431,3.769a5.79,5.79,0,0,0-4.6,5.777l.39,19a5.8,5.8,0,0,0,5.9,5.665l23.2-.339,1.911-.039.036,1.916c.02,1.387-.938,1.778-1.879,1.895v.038l-32.318.664-.2,0m.89-34.41-1.388.028a5.808,5.808,0,0,0-5.664,5.9l.391,19a5.8,5.8,0,0,0,5.9,5.664l1.6-.033a9.5,9.5,0,0,1-2.174-5.879l-.39-19a9.558,9.558,0,0,1,1.728-5.686",
    transform: "translate(-559.759 -1546.069)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10341",
    "data-name": "Path 10341",
    d: "M773.2,1870.407c.01.7-.893,6.39-.893,6.39l-4,.059c-2.757.041-5.034-2.78-5.086-6.3s2.14-6.408,4.9-6.449l4-.059s1.065,5.216,1.082,6.361",
    transform: "translate(-670.128 -1636.7)",
    fill: "#22a7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10342",
    "data-name": "Path 10342",
    d: "M773.2,1870.407c.01.7-.893,6.39-.893,6.39l-4,.059c-2.757.041-5.034-2.78-5.086-6.3s2.14-6.408,4.9-6.449l4-.059s1.065,5.216,1.082,6.361",
    transform: "translate(-670.128 -1636.7)",
    fill: "#c49714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10343",
    "data-name": "Path 10343",
    d: "M757.953,1868.128a5.9,5.9,0,0,1-4.607-2.347,9.107,9.107,0,0,1-.16-10.777,5.885,5.885,0,0,1,4.619-2.484l2.795-.042h.042a2.877,2.877,0,0,1,2.826,2.327,45.465,45.465,0,0,1,.872,5.423h0a46.175,46.175,0,0,1-.722,5.42,2.87,2.87,0,0,1-2.8,2.437l-2.781.042h-.083m2.711-12.775-2.817.024a3.1,3.1,0,0,0-2.385,1.355,6.26,6.26,0,0,0,.108,7.255,3.118,3.118,0,0,0,2.424,1.283l2.781-.041c.516-3.219.7-4.682.709-4.967a48.72,48.72,0,0,0-.819-4.908",
    transform: "translate(-659.844 -1626.542)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10344",
    "data-name": "Path 10344",
    d: "M806.021,1870.344c.052,3.521-2.141,6.408-4.9,6.449s-5.034-2.781-5.086-6.3,2.14-6.408,4.9-6.449,5.034,2.78,5.086,6.3",
    transform: "translate(-698.949 -1636.696)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7049",
    "data-name": "Group 7049",
    transform: "translate(97.089 227.346)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7048",
    "data-name": "Group 7048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7047",
    "data-name": "Group 7047",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10345",
    "data-name": "Path 10345",
    d: "M796.048,1870.494c0,.265.02.523.048.777.488-2.8,2.425-4.908,4.777-4.944,2.553-.038,4.688,2.375,5.037,5.524a7.8,7.8,0,0,0,.119-1.507c-.052-3.521-2.328-6.34-5.086-6.3s-4.948,2.929-4.9,6.451",
    transform: "translate(-796.047 -1864.043)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10346",
    "data-name": "Path 10346",
    d: "M796.049,1900.2c.052,3.517,2.328,6.34,5.086,6.3s4.948-2.929,4.9-6.451a7.885,7.885,0,0,0-.184-1.6c-.692,2.385-2.477,4.09-4.591,4.122-2.32.037-4.3-1.957-4.9-4.691a8.044,8.044,0,0,0-.3,2.325",
    transform: "translate(-698.959 -1666.402)",
    fill: "#c49714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10347",
    "data-name": "Path 10347",
    d: "M790.781,1867.936c-3.505,0-6.394-3.439-6.457-7.709-.064-4.3,2.765-7.847,6.3-7.9h.079c3.505,0,6.394,3.439,6.457,7.709h0c.064,4.3-2.764,7.846-6.3,7.9h-.079m-.074-12.752h-.036c-1.931.028-3.529,2.318-3.489,5,.039,2.665,1.684,4.895,3.6,4.895h.036c1.931-.029,3.529-2.318,3.489-5-.039-2.665-1.684-4.895-3.6-4.895",
    transform: "translate(-688.664 -1626.409)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10348",
    "data-name": "Path 10348",
    d: "M912.074,1798.1h0a1.428,1.428,0,0,1-1.424-1.433l.03-9.615a8.053,8.053,0,0,1,3.636-6.719,5.188,5.188,0,0,0,2.348-4.445l-.231-13.552a1.429,1.429,0,0,1,2.857-.049l.231,13.552a8.033,8.033,0,0,1-3.635,6.882,5.2,5.2,0,0,0-2.349,4.34l-.03,9.615a1.429,1.429,0,0,1-1.429,1.425",
    transform: "translate(-799.579 -1546.12)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10349",
    "data-name": "Path 10349",
    d: "M365.477,1846.052s-4.765,1.51-5.37,5.7a8.535,8.535,0,0,0,4.271,8.558s20.789,5.536,31.753.685c0,0,7.118-5.825-.37-12.383,0,0-16.161,1.587-30.284-2.563",
    transform: "translate(-316.104 -1620.9)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7052",
    "data-name": "Group 7052",
    transform: "translate(43.909 228.555)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7051",
    "data-name": "Group 7051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7050",
    "data-name": "Group 7050",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10350",
    "data-name": "Path 10350",
    d: "M396.134,1885.5c-10.963,4.848-31.752-.686-31.752-.686a8.534,8.534,0,0,1-4.272-8.559,5.861,5.861,0,0,1,.853-2.3,8.307,8.307,0,0,0,1.9,3.287,7.215,7.215,0,0,0,3.684,2.1c4.658,1.079,18.835,3.924,28.171,1.063a7.1,7.1,0,0,0,4.036-3.171l.027-.046c1.743,4.719-2.648,8.311-2.648,8.311",
    transform: "translate(-360.015 -1873.957)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10351",
    "data-name": "Path 10351",
    d: "M370.445,1850.554a89.343,89.343,0,0,1-20.295-2.741l-.206-.055-.189-.1c-.258-.136-6.3-3.395-5.272-10.518.767-5.313,6.438-7.17,6.679-7.246l.554-.176.558.164c13.588,3.993,29.4,2.51,29.561,2.5l.82-.08.621.543c2.752,2.409,4.123,5.061,4.076,7.881-.073,4.347-3.6,7.287-3.754,7.41l-.2.163-.236.1c-3.62,1.6-8.167,2.155-12.719,2.155m-19.079-6.363c2.273.572,20.3,4.9,29.987.84a6.746,6.746,0,0,0,2.191-4.4,6.21,6.21,0,0,0-2.2-4.392c-3.54.267-17.071.977-29.511-2.523-1.009.449-3.251,1.691-3.579,3.966a6.556,6.556,0,0,0,3.112,6.506",
    transform: "translate(-302.365 -1606.559)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10352",
    "data-name": "Path 10352",
    d: "M1230.024,691.05c-.346,8.22-1.945,16.13-5.616,19.181-2.637,2.192-22.384,4.3-22.384,4.3l9.9-52.6s1.341.231,3.24.664c3.948.905,10.318,2.708,12,5.2,1.83,2.709,3.276,13.213,2.858,23.251",
    transform: "translate(-1055.421 -581.2)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7055",
    "data-name": "Group 7055",
    transform: "translate(146.603 80.732)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7054",
    "data-name": "Group 7054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7053",
    "data-name": "Group 7053",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10353",
    "data-name": "Path 10353",
    d: "M1230.024,691.05c-.346,8.22-1.945,16.13-5.616,19.181-2.637,2.192-22.384,4.3-22.384,4.3l9.9-52.6s1.341.231,3.24.664a90.976,90.976,0,0,1,5.982,26.231c.565,7.622,5.834,7.594,8.877,2.223",
    transform: "translate(-1202.024 -661.932)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10354",
    "data-name": "Path 10354",
    d: "M1182.786,700.929l10.722-56.964,1.846.314c2.262.385,13.69,2.518,16.5,6.68,2.214,3.278,3.327,13.577,3.25,21.6-.065,6.8-.978,18.87-6.37,23.354-2.856,2.375-18.631,4.227-23.4,4.738Zm13.768-52.545-9.072,48.195c8.463-1.008,17.458-2.556,18.821-3.594,7.2-5.987,5.318-35.561,2.394-39.893-1.24-1.837-7.322-3.711-12.143-4.707",
    transform: "translate(-1038.529 -565.424)",
    fill: "#371944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10355",
    "data-name": "Path 10355",
    d: "M213.412,359.865a71.2,71.2,0,1,0,67.073-75.1,71.2,71.2,0,0,0-67.073,75.1",
    transform: "translate(-187.282 -249.935)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10356",
    "data-name": "Path 10356",
    d: "M248.223,573.022a71.205,71.205,0,1,0,122.6-68.695c-4.066,35.751-47.472,65.783-102.027,68.862a158.045,158.045,0,0,1-20.573-.168",
    transform: "translate(-217.949 -442.817)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10357",
    "data-name": "Path 10357",
    d: "M270.683,415.243a73.222,73.222,0,1,1,4.214-.119c-1.408.079-2.815.119-4.214.119m.137-142.4c-1.311,0-2.624.037-3.948.112a69.294,69.294,0,0,0,3.861,138.477c1.311,0,2.624-.036,3.948-.111a69.294,69.294,0,0,0-3.861-138.478",
    transform: "translate(-173.562 -236.219)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10358",
    "data-name": "Path 10358",
    d: "M270.725,415.249a73.2,73.2,0,0,1-72.943-68.986h0a73.1,73.1,0,0,1,145.977-8.24c.022.391.039.788.055,1.179a73.042,73.042,0,0,1-68.924,75.929q-2.093.118-4.166.117m-69.139-69.2a69.293,69.293,0,0,0,138.421-6.69c-.015-.371-.031-.749-.052-1.121a69.295,69.295,0,0,0-138.369,7.811",
    transform: "translate(-173.557 -236.224)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M321.165,453.841c-38.529,0-70.754-28.206-72.814-64.685-1.037-18.374,5.641-36.074,18.8-49.838a75.673,75.673,0,0,1,50.728-23,76.541,76.541,0,0,1,42.827,10.058,1.9,1.9,0,0,1,.238.163,73.225,73.225,0,0,1,27.225,52.888c.021.372.037.749.052,1.121.023.233.037.462.05.7a58.692,58.692,0,0,1-1.147,15.344,73.173,73.173,0,0,1-40.883,53.155,1.82,1.82,0,0,1-.206.083,78.312,78.312,0,0,1-20.4,3.892q-2.25.127-4.474.126M322.391,320q-2.14,0-4.293.121a71.876,71.876,0,0,0-48.19,21.833c-12.425,12.993-18.73,29.68-17.753,46.989,1.945,34.453,32.488,61.088,69.01,61.09,1.412,0,2.829-.039,4.258-.12a74.515,74.515,0,0,0,19.3-3.666,69.385,69.385,0,0,0,38.662-50.387,54.982,54.982,0,0,0,1.083-14.385c-.012-.208-.022-.4-.042-.589,0-.041-.007-.082-.009-.123-.016-.372-.031-.75-.052-1.122A69.405,69.405,0,0,0,358.675,329.6a72.422,72.422,0,0,0-36.284-9.6",
    transform: "translate(-217.97 -277.624)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M320.573,448.822c1.881,33.333,32.337,58.728,68.02,56.714,30.248-1.707,54.547-22.562,60.1-49.178a56.657,56.657,0,0,0,1.11-14.829c-.013-.23-.026-.454-.05-.684-2.251-33-32.533-58.025-67.97-56.024-35.683,2.014-63.088,30.669-61.206,64",
    transform: "translate(-281.395 -337.787)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10361",
    "data-name": "Path 10361",
    d: "M320.573,799.159c1.881,33.333,32.336,58.728,68.02,56.714,26.837-1.515,48.991-18.1,57.518-40.417a72,72,0,0,1-51.153,25.06C358,842.6,326.223,817.507,321.817,783.709a56.515,56.515,0,0,0-1.244,15.45",
    transform: "translate(-281.395 -688.124)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7058",
    "data-name": "Group 7058",
    transform: "translate(74.117 57.153)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7057",
    "data-name": "Group 7057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7056",
    "data-name": "Group 7056",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M607.788,484.141s31.1-9.317,54.283,1.731l.073.035a30.236,30.236,0,0,1,12.021,10.37,60.83,60.83,0,0,1,7.306,14.651c4.486,12.592,4.2,19.331,4.2,19.331,4.9-9.205,6.311-18.2,2.68-28.721q-.541-1.555-1.228-3.162c-.1-.247-.213-.489-.327-.732,0,0,0-.009-.009-.014A74.065,74.065,0,0,0,682.2,489.9c-5.963-8.791-16.038-19.453-30.448-20.985-26.945-2.864-45.485,14.277-43.963,15.222",
    transform: "translate(-607.701 -468.597)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7061",
    "data-name": "Group 7061",
    transform: "translate(52.52 97.774)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7060",
    "data-name": "Group 7060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7059",
    "data-name": "Group 7059",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M450.1,812.083c.476,6.169-3.49,11.518-8.86,11.947s-10.108-4.224-10.584-10.393,3.49-11.518,8.86-11.947,10.108,4.224,10.584,10.392",
    transform: "translate(-430.616 -801.662)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7064",
    "data-name": "Group 7064",
    transform: "translate(59.821 127.234)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7063",
    "data-name": "Group 7063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7062",
    "data-name": "Group 7062",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10364",
    "data-name": "Path 10364",
    d: "M498.534,1047.851c-.022,2.555-1.842,4.621-4.066,4.613s-4.008-2.086-3.986-4.642,1.843-4.621,4.066-4.613,4.008,2.086,3.986,4.642",
    transform: "translate(-490.481 -1043.209)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M185.6,793.706l4.851,27.629,3.021,17.21,9.739-.087.92-.01c4.2-.826,5.687-12.42,3.323-25.876-.051-.3-.11-.613-.168-.916-2.434-13-7.611-22.746-11.713-21.933l-.861.342Z",
    transform: "translate(-162.959 -693.363)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7067",
    "data-name": "Group 7067",
    transform: "translate(27.486 116.727)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7066",
    "data-name": "Group 7066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7065",
    "data-name": "Group 7065",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10366",
    "data-name": "Path 10366",
    d: "M225.366,968.306l3.021,17.21,9.739-.086.92-.01c4.2-.825,5.687-12.42,3.323-25.876-.051-.3-.11-.613-.168-.916l-.734-1.565s-.67,5.917-3.349,6.985c-2.832,1.136-5.415-5.7-5.415-5.7Z",
    transform: "translate(-225.366 -957.062)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M179.75,826.724a1.9,1.9,0,0,1-1.876-1.576L170,780.309a1.9,1.9,0,0,1,1.169-2.1l9.973-3.986a1.889,1.889,0,0,1,.338-.1,5.064,5.064,0,0,1,3.917.956c4.208,2.882,8.215,12.083,10.208,23.439,2.287,13.022,1.362,26.847-4.829,28.074a1.942,1.942,0,0,1-.354.036l-10.658.1Zm-5.729-45.55,7.326,41.726,8.811-.079c1.936-.713,4.2-9.362,1.7-23.644-1.973-11.236-5.825-19.046-8.61-20.954a1.889,1.889,0,0,0-.909-.372Z",
    transform: "translate(-149.241 -679.636)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10368",
    "data-name": "Path 10368",
    d: "M152.575,842.979a.027.027,0,0,1,.007.014c.131,1.06.3,2.132.487,3.226,2.173,12.377,7.066,21.8,10.933,21.026,3.751-.743,5.159-10.828,3.237-22.77-.054-.34-.115-.687-.175-1.035-2.173-12.377-7.072-21.8-10.934-21.034-3.523.7-4.97,9.617-3.556,20.572",
    transform: "translate(-133.495 -722.065)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10369",
    "data-name": "Path 10369",
    d: "M156.5,991.511c.131,1.059.3,2.132.487,3.226,2.173,12.377,7.066,21.8,10.933,21.026,3.751-.743,5.159-10.828,3.237-22.77-1.154,4.577-3.748,12.716-7.353,10.894-2.105-1.071-5.093-7.211-7.3-12.376",
    transform: "translate(-137.414 -870.582)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10370",
    "data-name": "Path 10370",
    d: "M149.726,855.515a5.11,5.11,0,0,1-2.912-.983c-3.9-2.675-7.617-11.179-9.459-21.667-2.051-11.682-1.5-24.8,4.567-26a4.816,4.816,0,0,1,3.722.9c3.9,2.675,7.617,11.18,9.458,21.667,2.051,11.682,1.5,24.8-4.567,26a4.172,4.172,0,0,1-.809.079m-8.618-23.308c1.808,10.3,5.323,17.444,7.859,19.182a1.282,1.282,0,0,0,.827.31c1.546-.307,3.94-8.028,1.555-21.608-1.808-10.3-5.322-17.444-7.859-19.182a1.292,1.292,0,0,0-.828-.31c-1.546.307-3.939,8.029-1.555,21.608",
    transform: "translate(-119.659 -708.384)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10371",
    "data-name": "Path 10371",
    d: "M16.2,987.224c-.075-13.305,1.977-22.86,6.887-32.133,5.456-10.3,24.342-16.645,28.164-10.185,2.661,4.5-2.2,7.248-3.816,8.01a.472.472,0,0,0-.2.677A28.248,28.248,0,0,1,51.369,967c.073,5.965-1.4,11.388-8.707,13.842",
    transform: "translate(-14.226 -827.37)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10372",
    "data-name": "Path 10372",
    d: "M.569,973.662c-.086-9.9,1.134-20.089,5.26-29.228a49.594,49.594,0,0,1,2.431-4.819,27.719,27.719,0,0,1,11.047-9.506c4.411-2.165,9.342-3.8,14.352-3.114,3.96.483,7.218,3.942,6.407,8.144-.607,2.789-2.995,4.642-5.306,5.809l-.222.109a1.458,1.458,0,0,0,.778-1.557,1.4,1.4,0,0,0-.175-.461l.015.025.121.2c3.934,6.521,5.9,14.907,2.726,22.153a11.709,11.709,0,0,1-5.319,5.485,15.486,15.486,0,0,1-3.45,1.269.955.955,0,0,1-.606-1.806c2.941-1.335,5.27-3.274,6.316-6.238,1.914-6.348.227-13.431-3.047-19.077a2.414,2.414,0,0,1,1.173-3.515c1.589-.829,3.627-2.187,3.271-4.1-.364-1.613-1.581-2.422-3.3-2.674-6.9-.719-14.99,3.447-19.683,8.417a24.267,24.267,0,0,0-4.048,6.8,55.177,55.177,0,0,0-4.087,14.289,89.336,89.336,0,0,0-.846,13.381,1.905,1.905,0,0,1-3.81.015",
    transform: "translate(-0.496 -813.797)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10373",
    "data-name": "Path 10373",
    d: "M310.011,1310.664s2.092,7.9,2.092,12.519",
    transform: "translate(-272.201 -1150.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10374",
    "data-name": "Path 10374",
    d: "M297.839,1295.5a80.236,80.236,0,0,1,1.2,9.691,29.441,29.441,0,0,1,0,3.316.954.954,0,0,1-1.9,0,59.2,59.2,0,0,0-2.982-12.035,1.909,1.909,0,1,1,3.684-.972",
    transform: "translate(-258.187 -1136.138)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10375",
    "data-name": "Path 10375",
    d: "M1042.93,1312.488a12.538,12.538,0,0,0-11.922,10.264c-.918,5.672,2.938,10.268,8.606,10.268a12.539,12.539,0,0,0,11.926-10.268c.914-5.668-2.938-10.264-8.61-10.264m2.456,9.27a6.366,6.366,0,0,1-5.772,5.028,2.56,2.56,0,0,1-1.986-.769,2.767,2.767,0,0,1-.466-2.273,6.361,6.361,0,0,1,5.768-5.024,2.572,2.572,0,0,1,1.99.765,2.8,2.8,0,0,1,.466,2.273",
    transform: "translate(-905.144 -1152.411)",
    fill: "#dddcdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7070",
    "data-name": "Group 7070",
    transform: "translate(125.829 160.074)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7069",
    "data-name": "Group 7069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7068",
    "data-name": "Group 7068",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M1043.653,1312.47a12.539,12.539,0,0,0-11.926,10.268,2.411,2.411,0,0,0-.033.257,12.558,12.558,0,0,1,11.073-7.453,8.494,8.494,0,0,1,8.644,10.006,11.07,11.07,0,0,0,.848-2.81c.915-5.672-2.934-10.268-8.606-10.268",
    transform: "translate(-1031.693 -1312.47)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M1025.883,1321.208a10.527,10.527,0,0,1-8.185-3.632,10.748,10.748,0,0,1-2.3-8.845,14.523,14.523,0,0,1,13.8-11.865,10.529,10.529,0,0,1,8.185,3.629,10.749,10.749,0,0,1,2.3,8.843,14.526,14.526,0,0,1-13.806,11.869m3.316-20.531a10.582,10.582,0,0,0-10.041,8.662,7,7,0,0,0,1.442,5.769,6.779,6.779,0,0,0,5.283,2.291,10.584,10.584,0,0,0,10.045-8.665,7.006,7.006,0,0,0-1.445-5.767,6.782,6.782,0,0,0-5.284-2.289m-3.316,14.3a4.4,4.4,0,0,1-3.438-1.44,4.62,4.62,0,0,1-.894-3.816,8.294,8.294,0,0,1,7.648-6.62,4.412,4.412,0,0,1,3.438,1.431,4.657,4.657,0,0,1,.9,3.813v0a8.3,8.3,0,0,1-7.652,6.63m3.316-8.066a4.5,4.5,0,0,0-3.887,3.422,1.22,1.22,0,0,0,.037.737,1.055,1.055,0,0,0,.534.1,4.509,4.509,0,0,0,3.89-3.424,1.238,1.238,0,0,0-.041-.746,1.253,1.253,0,0,0-.533-.086m2.456,1.133h0Z",
    transform: "translate(-891.413 -1138.696)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10378",
    "data-name": "Path 10378",
    d: "M779.141,1396.66,768.177,1430.1l-9.816,29.952H704.5l6.077-18.541,14.7-44.849Z",
    transform: "translate(-618.578 -1226.318)",
    fill: "#edae3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10379",
    "data-name": "Path 10379",
    d: "M768.178,1642.75l-9.816,29.952H704.5l6.077-18.541s4.715,10.825,19.9,12.83a14.507,14.507,0,0,0,16.345-13.283,21.75,21.75,0,0,1,4.42-11.716c4.324-5.629,11.659-2.634,16.936.757",
    transform: "translate(-618.578 -1438.969)",
    fill: "#d18c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10380",
    "data-name": "Path 10380",
    d: "M744.66,1448.231H690.8a1.9,1.9,0,0,1-1.81-2.5l20.778-63.389a1.906,1.906,0,0,1,1.81-1.312h53.859a1.905,1.905,0,0,1,1.81,2.5l-20.778,63.389a1.906,1.906,0,0,1-1.81,1.312m-51.23-3.81h49.85l19.529-59.579H712.959Z",
    transform: "translate(-604.875 -1212.595)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10381",
    "data-name": "Path 10381",
    d: "M993.514,1405.041H961.471l2.619-8.39h32.043Z",
    transform: "translate(-844.206 -1226.309)",
    fill: "#dddcdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7073",
    "data-name": "Group 7073",
    transform: "translate(117.267 170.343)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7072",
    "data-name": "Group 7072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7071",
    "data-name": "Group 7071",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10382",
    "data-name": "Path 10382",
    d: "M994.6,1401.618l-1.072,3.429H961.484l2.619-8.387h3.52l-.6,1.908a2.35,2.35,0,0,0,2.243,3.05Z",
    transform: "translate(-961.484 -1396.66)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10383",
    "data-name": "Path 10383",
    d: "M979.8,1393.232H947.756a1.9,1.9,0,0,1-1.818-2.473l2.619-8.39a1.905,1.905,0,0,1,1.819-1.338h32.043a1.905,1.905,0,0,1,1.818,2.473l-2.619,8.39a1.9,1.9,0,0,1-1.818,1.338m-29.453-3.81H978.4l1.43-4.58H951.776Z",
    transform: "translate(-830.491 -1212.595)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10384",
    "data-name": "Path 10384",
    d: "M1099.183,1580.114a103.056,103.056,0,0,1-2.5,11.654.074.074,0,0,1,0,.019c-2.381,8.32-5.291,11.835-8.772,11.83-17.2-.019-17.493-14.9-12.859-23.384,5.072-9.292,18.06-5.7,18.06-5.7l2.329-7.11s5.315,3.077,3.744,12.692",
    transform: "translate(-941.697 -1376.253)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7076",
    "data-name": "Group 7076",
    transform: "translate(130.807 203.98)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7075",
    "data-name": "Group 7075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7074",
    "data-name": "Group 7074",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10385",
    "data-name": "Path 10385",
    d: "M1096.683,1684.017c-2.381,8.32-5.291,11.835-8.773,11.83-17.2-.019-17.493-14.9-12.859-23.384,0,0-2.638,13.406,7.449,16.583,10.754,3.381,14.021-4.615,14.183-5.029",
    transform: "translate(-1072.503 -1672.463)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10386",
    "data-name": "Path 10386",
    d: "M1074.232,1591.8h-.008c-9.061-.01-13.274-3.911-15.213-7.183-3.489-5.887-2.171-13.793.682-19.017,4.584-8.394,14.4-7.7,18.453-7.009l1.8-5.485a1.905,1.905,0,0,1,2.764-1.056c.263.153,6.433,3.86,4.668,14.652-2.84,17.356-6.894,25.1-13.145,25.1m-.531-29.795c-3.634,0-8.244.989-10.664,5.42-2.26,4.138-3.458,10.675-.748,15.248,2.087,3.521,6.1,5.31,11.939,5.316h0c2.648,0,6.424-3.8,9.386-21.9.709-4.336-.117-7.088-1.059-8.722l-1.323,4.039a1.905,1.905,0,0,1-2.318,1.243,21.605,21.605,0,0,0-5.216-.64",
    transform: "translate(-928.011 -1362.532)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10387",
    "data-name": "Path 10387",
    d: "M169.982,1353.114a1.429,1.429,0,0,1-.478-2.776c17.143-6.081,15.444-31.206,15.425-31.46a1.429,1.429,0,0,1,2.849-.218c.086,1.122,1.893,27.557-17.319,34.371a1.429,1.429,0,0,1-.478.083",
    transform: "translate(-147.995 -1156.673)",
    fill: "#292d39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "QuestionMark",
    transform: "translate(172.549 -21.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10395",
    "data-name": "Path 10395",
    d: "M48.207,242.9c-3-1.054-8.189-4.865-8.189-9.406,0-3.081,1.864-5.594,7.054-9.73,4.459-3.486,6.729-5.838,6.729-8.838a5.21,5.21,0,0,0-5.513-5.432c-5.352,0-8.514,5.027-9.568,5.027a4.41,4.41,0,0,1-3.487-3.81,3.786,3.786,0,0,1,1.541-3,14.181,14.181,0,0,1,8.757-2.919,13.1,13.1,0,0,1,12.891,12.73c0,3.406-1.135,6.324-5.757,10.134-4.054,3.406-6.243,4.946-6.243,7.622,0,2.189,1.135,3.649,3.324,5.676ZM46.18,259.763a5.192,5.192,0,0,1,0-10.378,5.039,5.039,0,0,1,5.027,5.189,4.943,4.943,0,0,1-5.027,5.189",
    transform: "translate(-30.937 -179.813)",
    fill: "#d50511"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10396",
    "data-name": "Path 10396",
    d: "M18.1,177.36a13.1,13.1,0,0,1,12.891,12.73c0,3.405-1.135,6.324-5.757,10.135-4.054,3.405-6.243,4.946-6.243,7.622,0,2.189,1.135,3.649,3.324,5.676l-1.541,1.946c-3-1.054-8.189-4.866-8.189-9.406,0-3.081,1.864-5.594,7.054-9.73,4.459-3.486,6.729-5.838,6.729-8.838a5.21,5.21,0,0,0-5.513-5.432c-5.352,0-8.514,5.027-9.568,5.027a4.41,4.41,0,0,1-3.487-3.811,3.786,3.786,0,0,1,1.541-3A14.181,14.181,0,0,1,18.1,177.36m.648,44.595a5.039,5.039,0,0,1,5.027,5.189,4.943,4.943,0,0,1-5.027,5.189,5.192,5.192,0,0,1,0-10.378m-.648-48.4c-1.57,0-7.016.275-11.214,3.817q-.069.058-.135.12a7.572,7.572,0,0,0-2.759,5.792c0,4.1,4.012,7.621,7.3,7.621,1.8,0,2.983-1.079,4.132-2.122,1.351-1.226,3.2-2.905,5.436-2.905a1.453,1.453,0,0,1,1.7,1.622c0,1.238-1.476,2.874-5.266,5.836l-.028.022c-5.377,4.285-8.49,7.738-8.49,12.709,0,5.483,4.659,10,8.8,12.153a9.015,9.015,0,0,0,1.172,17.927,8.724,8.724,0,0,0,8.838-9,8.9,8.9,0,0,0-5.191-8.226,3.8,3.8,0,0,0,1.368-1.084l1.541-1.946a3.81,3.81,0,0,0-.4-5.161c-2.1-1.946-2.1-2.421-2.1-2.88,0-.635,1.743-2.087,3.763-3.768q.529-.441,1.108-.926c5-4.123,7.128-8.031,7.128-13.062a16.912,16.912,0,0,0-16.7-16.54",
    transform: "translate(-3.508 -152.383)",
    fill: "#292d39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rocket",
    transform: "translate(-181.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10397",
    "data-name": "Path 10397",
    d: "M2295.688,2024.061s21.541-1.3,26.4,7.511c3.029,5.5.143,23.232-.705,30.776-.676,6.034,2.911,5.629,2.911,5.629s16.678-13.626,23.026-31.4l0,0c2.715-7.6,3.543-15.959.372-24.337-3.229-8.544-10.068-13.964-17.179-17.4a65.921,65.921,0,0,0-22.655-5.877Z",
    transform: "translate(-2015.697 -1746.375)",
    fill: "#f73939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M2295.688,2024.061s21.541-1.3,26.4,7.511c3.029,5.5.143,23.232-.705,30.776-.676,6.034,2.911,5.629,2.911,5.629s16.678-13.626,23.026-31.4c-.276.286-10.477,10.845-16.779,7.344-3.29-1.827-1.309-9.356-3.857-16.036a30.08,30.08,0,0,1-.5-20.756l4.333-12.3a65.921,65.921,0,0,0-22.655-5.877Z",
    transform: "translate(-2015.697 -1746.375)",
    fill: "#d82345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10399",
    "data-name": "Path 10399",
    d: "M2310.429,2056.149a4.48,4.48,0,0,1-3.106-1.3c-1.35-1.349-1.868-3.52-1.539-6.452.125-1.109.293-2.436.48-3.911.957-7.544,2.737-21.584.448-25.735-3.5-6.351-18.955-6.866-24.615-6.527a1.9,1.9,0,0,1-1.914-2.525l12.173-35.108a1.888,1.888,0,0,1,1.892-1.279c1.341.065,32.946,1.847,41.524,24.51,4.559,12.045,1.812,25.916-7.944,40.112a93.553,93.553,0,0,1-16.037,17.779,1.909,1.909,0,0,1-.99.418,3.514,3.514,0,0,1-.37.02m-25.141-47.821c6.666,0,20.552.952,24.76,8.581,2.669,4.838,1.521,16.031,0,28.055-.185,1.455-.351,2.763-.474,3.857-.263,2.344.254,3.121.419,3.3a.832.832,0,0,0,.063.062c4.638-4.058,31.322-28.8,22.156-53.016-6.729-17.779-30.661-21.318-36.736-21.935l-10.782,31.1c.192,0,.392,0,.6,0",
    transform: "translate(-2001.99 -1732.633)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7092",
    "data-name": "Group 7092",
    transform: "translate(320.837 257.542)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6994",
    "data-name": "Group 6994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6993",
    "data-name": "Group 6993",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10268",
    "data-name": "Path 10268",
    d: "M2630.592,2111.621a25.717,25.717,0,0,1,7.4,21.964s-6.051-10.254-7.4-21.964",
    transform: "translate(-2630.592 -2111.621)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M1563.5,2024.061s-21.541-1.3-26.4,7.511c-3.029,5.5-.143,23.232.705,30.776.676,6.034-2.91,5.629-2.91,5.629s-16.679-13.626-23.027-31.4l0,0c-2.715-7.6-3.543-15.959-.372-24.337,3.229-8.544,10.068-13.964,17.179-17.4a65.921,65.921,0,0,1,22.656-5.877Z",
    transform: "translate(-1325.349 -1746.375)",
    fill: "#f73939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10401",
    "data-name": "Path 10401",
    d: "M1580.925,2024.061s-21.541-1.3-26.4,7.511c-3.029,5.5-.143,23.232.705,30.776.676,6.034-2.91,5.629-2.91,5.629s-16.679-13.626-23.027-31.4c.276.286,10.478,10.845,16.778,7.344,3.29-1.827,1.309-9.356,3.858-16.036a30.079,30.079,0,0,0,.5-20.756l-4.334-12.3a65.922,65.922,0,0,1,22.655-5.877Z",
    transform: "translate(-1342.775 -1746.375)",
    fill: "#d82345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10402",
    "data-name": "Path 10402",
    d: "M1521.511,2056.148a3.425,3.425,0,0,1-.369-.02,1.907,1.907,0,0,1-.991-.418,93.576,93.576,0,0,1-16.037-17.779c-9.756-14.2-12.5-28.067-7.944-40.112,8.578-22.663,40.182-24.445,41.524-24.51a1.885,1.885,0,0,1,1.892,1.279l12.173,35.107a1.9,1.9,0,0,1-1.914,2.526c-5.66-.338-21.112.176-24.615,6.527-2.289,4.151-.509,18.191.448,25.735.187,1.475.355,2.8.48,3.911.329,2.932-.188,5.1-1.539,6.452a4.48,4.48,0,0,1-3.107,1.3m14.958-78.916c-6.075.617-30.007,4.156-36.736,21.935-9.177,24.245,17.515,48.963,22.155,53.016a.675.675,0,0,0,.064-.062c.165-.182.682-.958.419-3.3-.123-1.093-.289-2.4-.473-3.857-1.525-12.024-2.672-23.217,0-28.055,4.338-7.865,18.957-8.637,25.359-8.579Z",
    transform: "translate(-1311.809 -1732.633)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10403",
    "data-name": "Path 10403",
    d: "M1802.3,2198.078l2.583,12.088a15.2,15.2,0,0,0,10.614,11.418,91.255,91.255,0,0,0,49.036.56h0a15.2,15.2,0,0,0,10.872-11.173l2.857-12.026Z",
    transform: "translate(-1582.487 -1929.991)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7093",
    "data-name": "Group 7093",
    transform: "translate(257.081 268.953)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7015",
    "data-name": "Group 7015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7014",
    "data-name": "Group 7014",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10293",
    "data-name": "Path 10293",
    d: "M2110.657,2231.458q-1.4.021-2.805,0a91.282,91.282,0,0,0,19.253-2.982,15.195,15.195,0,0,0,10.875-11.176l2.854-12.024,2.8.038,2.914-.122-2.86,12.023a15.2,15.2,0,0,1-10.87,11.176,91.312,91.312,0,0,1-22.16,3.072",
    transform: "translate(-2107.851 -2205.186)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10404",
    "data-name": "Path 10404",
    d: "M1842.38,2225.235a91.353,91.353,0,0,1-26.873-3.632,15.208,15.208,0,0,1-10.616-11.416l-2.581-12.088,39.753.45c-2.594,1.4-5.927,4.489-5.828,11.174.161,10.894,10.674,15.316,10.674,15.316s.026,0,.036.009c-1.517.105-3.041.164-4.565.187",
    transform: "translate(-1582.493 -1930.01)",
    fill: "#292d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10405",
    "data-name": "Path 10405",
    d: "M1687.1,213.373c-.357,1.815-.738,3.6-1.129,5.339a193.163,193.163,0,0,1-9.463,30.38q-1.844,4.536-3.7,8.43c-7.491,15.874-14.369,23.8-14.369,23.8a109.757,109.757,0,0,1-14.25,4.029c-.19.038-.381.081-.572.119a109.264,109.264,0,0,1-59.208-4.305q-.965-.343-1.924-.714s-19.141-23.065-27.113-68.619a245.921,245.921,0,0,1-2.548-62.275c6.6-82.147,48.558-121.354,64.539-133.446a9.986,9.986,0,0,1,12.226.129c9.808,7.78,29.539,26.394,44.1,59.364a206.009,206.009,0,0,1,15.054,52.926c.871,5.8,1.557,11.84,2.019,18.136.119,1.476.214,2.972.3,4.472a246.41,246.41,0,0,1-3.977,62.237",
    transform: "translate(-1362.667 -12.365)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7094",
    "data-name": "Group 7094",
    transform: "translate(193.225 161.955)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7018",
    "data-name": "Group 7018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7017",
    "data-name": "Group 7017",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10296",
    "data-name": "Path 10296",
    d: "M1715.01,1366.948c-.357,1.815-.738,3.6-1.129,5.339a193.16,193.16,0,0,1-9.463,30.38q-1.843,4.537-3.7,8.43c-7.492,15.874-14.369,23.8-14.369,23.8a109.748,109.748,0,0,1-14.25,4.029l-.1.119a109.261,109.261,0,0,1-59.208-4.305c-.99-1.186-7.353-9.063-14.235-23.641q-1.843-3.9-3.7-8.43a193.185,193.185,0,0,1-9.463-30.38c-.39-1.743-.771-3.524-1.129-5.339,16.493,37.186,46.411,36.305,42.211,17.636-1.357-6.025-14.835-15.331-14.835-50.321l37.991-6.368,37.991,6.368c0,34.99-13.478,44.3-14.836,50.321-4.2,18.669,25.718,19.55,42.211-17.636",
    transform: "translate(-1584.277 -1327.895)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10406",
    "data-name": "Path 10406",
    d: "M1790.431,85.717A263.834,263.834,0,0,0,1680.22,84.46c15.607-38.963,38.806-60.037,49.769-68.338a10,10,0,0,1,12.24.138c.271.214.552.438.838.671,11.073,8.978,33.024,30.466,47.364,68.786",
    transform: "translate(-1475.294 -12.379)",
    fill: "#d50511"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10407",
    "data-name": "Path 10407",
    d: "M2198.778,100.013c7.315-23.889,1.557-48.554-3.267-62.69,11.073,8.977,33.024,30.466,47.364,68.786a263.284,263.284,0,0,0-44.1-6.1",
    transform: "translate(-1927.738 -32.771)",
    fill: "#d54f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10408",
    "data-name": "Path 10408",
    d: "M1776.719,75.237a1.919,1.919,0,0,1-.419-.047,260.183,260.183,0,0,0-109.417-1.248,1.9,1.9,0,0,1-2.145-2.576c15.349-38.324,37.842-59.531,49.884-68.761a12.585,12.585,0,0,1,15.573.177c11.83,9.5,33.837,31.215,48.309,69.881a1.905,1.905,0,0,1-1.784,2.573m-58.012-10.316a264.667,264.667,0,0,1,54.964,5.794C1759.532,34.956,1739,14.739,1727.809,5.754a8.784,8.784,0,0,0-10.87-.124c-11.387,8.728-32.376,28.472-47.326,63.9a265.075,265.075,0,0,1,49.094-4.607",
    transform: "translate(-1461.58 0.004)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M1608.034,744.651c-.429,0-.858,0-1.287-.007a110.9,110.9,0,0,1-38.566-7.37,1.907,1.907,0,0,1-.784-.563c-.382-.46-9.454-11.535-17.756-33.461-7.628-20.147-15.96-53.641-12.331-98.8,1.9-23.673,6.91-45.768,14.885-65.673a1.906,1.906,0,0,1,1.475-1.174,263.945,263.945,0,0,1,110.933,1.282,1.906,1.906,0,0,1,1.365,1.19c7.519,20.081,12.022,42.285,13.383,66,2.6,45.231-6.494,78.527-14.578,98.495-8.8,21.731-18.119,32.6-18.511,33.048a1.912,1.912,0,0,1-.8.544,110.808,110.808,0,0,1-37.43,6.495m-38-10.749a107.427,107.427,0,0,0,73.661.841c1.679-2.068,9.944-12.761,17.625-31.8,7.9-19.577,16.78-52.237,14.229-96.657a221.572,221.572,0,0,0-12.789-63.913,260.14,260.14,0,0,0-107.407-1.223,221.581,221.581,0,0,0-14.243,63.6c-3.563,44.35,4.572,77.2,12.024,96.956,7.246,19.2,15.265,30.082,16.9,32.192",
    transform: "translate(-1349.044 -467.406)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10410",
    "data-name": "Path 10410",
    d: "M1827.3,2213.414a93.152,93.152,0,0,1-26.053-3.717,17.085,17.085,0,0,1-11.945-12.849l-2.582-12.088a1.905,1.905,0,0,1,3.726-.8l2.583,12.088a13.279,13.279,0,0,0,9.284,9.988,89.35,89.35,0,0,0,48.012.547,13.28,13.28,0,0,0,9.51-9.773l2.858-12.026a1.905,1.905,0,0,1,3.707.881l-2.858,12.026a17.085,17.085,0,0,1-12.234,12.573,93.153,93.153,0,0,1-24.007,3.146",
    transform: "translate(-1568.769 -1916.275)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M1888.217,1045.96a38.558,38.558,0,0,1-73.6,1.376l0,0a38.55,38.55,0,1,1,73.6-1.372",
    transform: "translate(-1591.578 -875.07)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7095",
    "data-name": "Group 7095",
    transform: "translate(221.442 121.552)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7021",
    "data-name": "Group 7021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7020",
    "data-name": "Group 7020",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10303",
    "data-name": "Path 10303",
    d: "M1892.011,1029.883a39.789,39.789,0,0,0-76.368,0,38.549,38.549,0,0,1,76.368,0",
    transform: "translate(-1815.642 -996.624)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10412",
    "data-name": "Path 10412",
    d: "M1902.359,1339.88a38.558,38.558,0,0,1-73.6,1.377s10.516,7.272,9.411-9.887h53.231c-1.1,17.16,9.416,9.887,9.416,9.887Z",
    transform: "translate(-1605.72 -1168.99)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10413",
    "data-name": "Path 10413",
    d: "M1837.437,1061.9a40.509,40.509,0,1,1,2.448-.072q-1.227.073-2.448.072m.078-77.095q-1.09,0-2.192.065a36.624,36.624,0,1,0,2.192-.065",
    transform: "translate(-1577.865 -861.347)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10414",
    "data-name": "Path 10414",
    d: "M1933.236,1142.718a26.841,26.841,0,1,0-28.382-25.206,26.841,26.841,0,0,0,28.382,25.206",
    transform: "translate(-1672.488 -956.253)",
    fill: "#d50511"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10415",
    "data-name": "Path 10415",
    d: "M1968.1,1174.188a21.831,21.831,0,1,1,1.315-.039q-.659.039-1.315.039m.06-39.739q-.544,0-1.092.032a17.964,17.964,0,1,0,2.122,35.865h0a17.964,17.964,0,0,0-1.031-35.9",
    transform: "translate(-1708.97 -992.741)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10416",
    "data-name": "Path 10416",
    d: "M1917.916,1130.958a28.761,28.761,0,1,1,1.72-.051c-.576.035-1.15.051-1.72.051m.052-53.684q-.752,0-1.509.045a24.878,24.878,0,1,0,1.509-.045",
    transform: "translate(-1658.775 -942.539)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M1958.427,1114.326a26.841,26.841,0,1,0-25.2,28.38,26.842,26.842,0,0,0,25.2-28.38m-25.618,21.422a19.868,19.868,0,1,1,18.66-21.012,19.868,19.868,0,0,1-18.66,21.012",
    transform: "translate(-1672.476 -956.243)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    "data-name": "Path 10418",
    d: "M1917.9,1130.941a28.775,28.775,0,1,1,1.718-.051q-.864.052-1.718.051m.049-53.684q-.751,0-1.507.045a24.936,24.936,0,0,0,1.461,49.829c.495,0,.99-.015,1.491-.044a24.931,24.931,0,0,0,23.415-26.365h0a24.939,24.939,0,0,0-24.859-23.463m-.06,46.714a21.821,21.821,0,1,1,1.315-.039q-.659.039-1.315.039m.059-39.739q-.544,0-1.092.032a17.964,17.964,0,1,0,2.122,35.864h0a17.964,17.964,0,0,0-1.031-35.9",
    transform: "translate(-1658.758 -942.525)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10419",
    "data-name": "Path 10419",
    d: "M1968.1,1174.188a21.831,21.831,0,1,1,1.315-.039q-.659.039-1.315.039m.06-39.739q-.544,0-1.092.032a17.964,17.964,0,1,0,2.122,35.865h0a17.964,17.964,0,0,0-1.031-35.9",
    transform: "translate(-1708.97 -992.741)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M2048.762,2034.983c0,21.589-12.162,39.091-12.162,39.091s-12.162-17.5-12.162-39.091,12.162-39.09,12.162-39.09,12.162,17.5,12.162,39.09",
    transform: "translate(-1777.53 -1752.465)",
    fill: "#22a7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10421",
    "data-name": "Path 10421",
    d: "M2048.762,2034.983c0,21.589-12.162,39.091-12.162,39.091s-12.162-17.5-12.162-39.091,12.162-39.09,12.162-39.09,12.162,17.5,12.162,39.09",
    transform: "translate(-1777.53 -1752.465)",
    fill: "#f73939"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7096",
    "data-name": "Group 7096",
    transform: "translate(249.866 243.429)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7024",
    "data-name": "Group 7024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7023",
    "data-name": "Group 7023",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10314",
    "data-name": "Path 10314",
    d: "M2067.1,2015.9l-1.057.662s-4.172-10.02-6.949-12.768c-.381,14.421-1.2,32-1.2,32s-.814-17.574-1.2-32c-2.777,2.753-6.948,12.763-6.948,12.763l-1.057-.667A81.437,81.437,0,0,1,2056.57,1998c.815-1.357,1.324-2.1,1.324-2.1s.51.734,1.319,2.086a81.536,81.536,0,0,1,7.882,17.907",
    transform: "translate(-2048.688 -1995.907)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10422",
    "data-name": "Path 10422",
    d: "M2048.761,2240.781c0,21.594-12.159,39.091-12.159,39.091s-12.164-17.5-12.164-39.091a61.811,61.811,0,0,1,.919-10.5c2.838,16.488,6.247,33.49,11.245,33.49s8.406-17,11.239-33.49a61.785,61.785,0,0,1,.92,10.5",
    transform: "translate(-1777.53 -1958.266)",
    fill: "#d82345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10423",
    "data-name": "Path 10423",
    d: "M2022.884,2062.261a1.9,1.9,0,0,1-1.564-.818c-.51-.734-12.5-18.243-12.5-40.177s11.992-39.444,12.5-40.178a1.9,1.9,0,0,1,3.129,0c.51.734,12.5,18.244,12.5,40.178s-11.992,39.443-12.5,40.177a1.905,1.905,0,0,1-1.564.818m0-76.48c-3.213,5.508-10.259,19.418-10.259,35.485s7.043,29.971,10.257,35.481c3.214-5.51,10.257-19.419,10.257-35.481,0-16.1-7.041-29.984-10.255-35.485",
    transform: "translate(-1763.814 -1738.748)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7097",
    "data-name": "Group 7097",
    transform: "translate(189.676 257.542)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7027",
    "data-name": "Group 7027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7026",
    "data-name": "Group 7026",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M1562.806,2111.621a25.718,25.718,0,0,0-7.4,21.964s6.051-10.254,7.4-21.964",
    transform: "translate(-1555.178 -2111.621)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7098",
    "data-name": "Group 7098",
    transform: "translate(243.902 143.864)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7078",
    "data-name": "Group 7078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7077",
    "data-name": "Group 7077",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M2000.375,1195.366c-1.555-1.108-.085-8.185,5.337-12.58,5.617-4.552,13.26-3.527,13.153-1.555-.147,2.71-4.385,1.933-10.17,6.514-3.546,2.808-6.766,8.728-8.32,7.621",
    transform: "translate(-1999.791 -1179.559)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7099",
    "data-name": "Group 7099",
    transform: "translate(243.683 161.57)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7081",
    "data-name": "Group 7081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7080",
    "data-name": "Group 7080",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M1999.836,1331.042c-2.129-2.2-2.514-5.523-.65-6.177,2.17-.762,3.93,1.992,5.579,3.769,2.853,3.076-1.307,6.143-4.929,2.409",
    transform: "translate(-1997.989 -1324.734)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7100",
    "data-name": "Group 7100",
    transform: "translate(229.574 14.513)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7084",
    "data-name": "Group 7084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7083",
    "data-name": "Group 7083",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10394",
    "data-name": "Path 10394",
    d: "M1904.088,119.405c-9.317,5.414-26.314,29.336-20.648,37.016,5.39,7.306,29.965-42.43,20.648-37.016",
    transform: "translate(-1882.309 -118.992)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5963",
    "data-name": "Rectangle 5963",
    width: 354.321,
    height: 337.354,
    fill: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.5d89f7d4fae5d1f83b1c1c43a0f2419d.svg";
export { ForwardRef as ReactComponent };